import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import GAPageTracker from "@/components/GAPageTracker";
import Home from "@/pages/Home";
import IVFluid from "@/pages/IVFluid";
import PediatricDosing from "@/pages/PediatricDosing";
import DripRate from "@/pages/DripRate";
import Electrolytes from "@/pages/Electrolytes";
import NIHSS from "@/pages/NIHSS";
import Alvarado from "@/pages/Alvarado";
import BMI from "@/pages/BMI";
import ObGyn from "@/pages/ObGyn";
import EmergencyDrugs from "@/pages/EmergencyDrugs";
import Heparin from "@/pages/Heparin";
import Baxter from "@/pages/Baxter";
import AlgorithmSpecialty from "@/pages/AlgorithmSpecialty";
import AlgorithmDetail from "@/pages/AlgorithmDetail";
import Killip from "@/pages/Killip";
import Sofa from "@/pages/Sofa";
import News from "@/pages/News";
import Apgar from "@/pages/Apgar";
import Ballard from "@/pages/Ballard";
import Downe from "@/pages/Downe";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GAPageTracker />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/iv-fluid" element={<IVFluid />} />
            <Route path="/pediatric-dose" element={<PediatricDosing />} />
            <Route path="/drip-rate" element={<DripRate />} />
            <Route path="/electrolytes" element={<Electrolytes />} />
            <Route path="/nihss" element={<NIHSS />} />
            <Route path="/alvarado" element={<Alvarado />} />
            <Route path="/bmi" element={<BMI />} />
            <Route path="/obgyn" element={<ObGyn />} />
            <Route path="/emergency-drugs" element={<EmergencyDrugs />} />
            <Route path="/heparin" element={<Heparin />} />
            <Route path="/baxter" element={<Baxter />} />
            <Route path="/killip" element={<Killip />} />
            <Route path="/sofa" element={<Sofa />} />
            <Route path="/news" element={<News />} />
            <Route path="/apgar" element={<Apgar />} />
            <Route path="/ballard" element={<Ballard />} />
            <Route path="/downe" element={<Downe />} />
            <Route path="/algorithm/:specialty" element={<AlgorithmSpecialty />} />
            <Route path="/algorithm/:specialty/:algoId" element={<AlgorithmDetail />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
